/** Beam colours on Prussian-blue paper (normal and high-contrast), by colour mask. */
const NORMAL: Record<number, string> = {
  7: '#fff3d9',
  1: '#ff8d72',
  2: '#8fe3a3',
  4: '#9cc3ff',
  3: '#ffe07a',
  5: '#ff9edd',
  6: '#8af0e6',
};
const CONTRAST: Record<number, string> = {
  7: '#ffffff',
  1: '#ff7457',
  2: '#6dff94',
  4: '#7fb7ff',
  3: '#ffe24d',
  5: '#ff85e4',
  6: '#4dfff0',
};

export const INK = '#f3ead3';
export const INK_DIM = 'rgba(243, 234, 211, 0.55)';
export const GOLD = '#e8c36a';
export const GOLD_BRIGHT = '#ffe2a0';
export const VOID = '#020a17';

export function beamColor(mask: number, contrast = false): string {
  return (contrast ? CONTRAST : NORMAL)[mask] ?? '#ffffff';
}

/**
 * Dash patterns (screen px) so colours never rely on hue alone. Primaries have distinct marks;
 * mixes combine their components' marks; white is solid.
 */
export function beamDash(mask: number): number[] {
  switch (mask) {
    case 1:
      return [11, 5];
    case 2:
      return [1.5, 5];
    case 4:
      return [5, 3, 5, 9];
    case 3:
      return [11, 4, 1.5, 4];
    case 5:
      return [11, 4, 5, 4];
    case 6:
      return [1.5, 4, 5, 4];
    default:
      return [];
  }
}

/** Draw the symbols of a colour (triangle = red, diamond = green, square = blue) centred at (x, y). */
export function drawColorGlyphs(
  ctx: CanvasRenderingContext2D,
  mask: number,
  x: number,
  y: number,
  size: number,
  fill: string,
): void {
  const parts = [1, 2, 4].filter((p) => (mask & p) !== 0);
  const gap = size * 1.25;
  const start = x - ((parts.length - 1) * gap) / 2;
  ctx.save();
  ctx.fillStyle = fill;
  parts.forEach((p, i) => {
    const cx = start + i * gap;
    const s = size / 2;
    ctx.beginPath();
    if (p === 1) {
      ctx.moveTo(cx, y - s * 1.05);
      ctx.lineTo(cx + s, y + s * 0.8);
      ctx.lineTo(cx - s, y + s * 0.8);
    } else if (p === 2) {
      ctx.moveTo(cx, y - s * 1.1);
      ctx.lineTo(cx + s, y);
      ctx.lineTo(cx, y + s * 1.1);
      ctx.lineTo(cx - s, y);
    } else {
      ctx.rect(cx - s * 0.82, y - s * 0.82, s * 1.64, s * 1.64);
    }
    ctx.closePath();
    ctx.fill();
  });
  ctx.restore();
}
